import i18n from "@/i18n";
import { IconKz, IconMd, IconRu, IconUz } from "@packages/icon-library";

const {
  global: { t },
} = i18n;

export const systemCountries = [
  {
    id: "ru",
    name: t("countries.ru"),
    icon: IconRu,
    currency: "RUB",
    features: {
      countrySelector: true,
      home: true,
      spend: true,
      fund: true,
      spendServices: true,
      spendPlaces: true,
      spendCoupons: true,
      receive: true,
      receivePlaces: true,
      receiveOffers: true,
      receiveProducts: true,
      market: true,
      cart: true,
      profile: {
        qrScan: true,
        scores: true,
        invite: true,
        tariffs: true,
        favorites: true,
        orders: true,
        coupons: true,
        giftsCards: true,
        activate: true,
      },
      footer: {
        copyright: true,
        app: true,
        payments: true,
        socials: true,
        companyInfo: false,
        contacts: false,
      },
      documents: {
        contacts: true,
        clientAgreement: true,
        agreements: true,
        policy: true,
        personalData: true,
        rules: true,
        licenseAgreement: true,
      },
    },
  },
  {
    id: "kz",
    name: t("countries.kz"),
    icon: IconKz,
    currency: "KZT",
    features: {
      countrySelector: true,
      home: true,
      spend: true,
      fund: true,
      spendServices: true,
      spendPlaces: true,
      spendCoupons: true,
      receive: true,
      receivePlaces: true,
      receiveOffers: true,
      receiveProducts: false,
      market: true,
      cart: true,
      profile: {
        qrScan: true,
        scores: true,
        invite: true,
        tariffs: true,
        favorites: true,
        orders: true,
        coupons: true,
        giftsCards: true,
        activate: true,
      },
      footer: {
        copyright: true,
        app: true,
        payments: true,
        socials: true,
        companyInfo: false,
        contacts: false,
      },
      documents: {
        contacts: true,
        clientAgreement: true,
        agreements: true,
        policy: true,
        personalData: true,
        rules: true,
        licenseAgreement: true,
      },
    },
  },
  {
    id: "md",
    name: t("countries.md"),
    icon: IconMd,
    currency: "MDL",
    features: {
      countrySelector: true,
      home: true,
      spend: true,
      fund: true,
      spendServices: false,
      spendPlaces: true,
      spendCoupons: false,
      receive: true,
      receivePlaces: true,
      receiveOffers: true,
      receiveProducts: false,
      market: true,
      cart: true,
      profile: {
        qrScan: true,
        scores: true,
        invite: true,
        tariffs: true,
        favorites: true,
        orders: true,
        coupons: true,
        giftsCards: true,
        activate: true,
      },
      footer: {
        copyright: true,
        app: true,
        payments: true,
        socials: true,
        companyInfo: false,
        contacts: false,
      },
      documents: {
        contacts: true,
        clientAgreement: true,
        agreements: true,
        policy: true,
        personalData: true,
        rules: true,
        licenseAgreement: true,
      },
    },
  },
  {
    id: "kg",
    name: t("countries.kg"),
    icon: IconMd,
    currency: "KGS",
    features: {
      countrySelector: false,
      home: true,
      spend: false,
      fund: false,
      spendServices: false,
      spendPlaces: false,
      spendCoupons: false,
      receive: false,
      receivePlaces: false,
      receiveOffers: false,
      receiveProducts: false,
      market: false,
      cart: false,
      profile: {
        qrScan: true,
        scores: true,
        invite: true,
        tariffs: true,
        favorites: true,
        orders: false,
        coupons: false,
        giftsCards: false,
        activate: true,
      },
      footer: {
        copyright: false,
        app: false,
        payments: false,
        socials: false,
        companyInfo: true,
        contacts: true,
      },
      documents: {
        contacts: false,
        clientAgreement: true,
        agreements: false,
        policy: true,
        personalData: true,
        rules: false,
        licenseAgreement: true,
      },
    },
  },
  {
    id: "uz",
    name: t("countries.uz"),
    icon: IconUz,
    currency: "UZS",
    features: {
      countrySelector: false,
      home: true,
      spend: false,
      fund: false,
      spendServices: false,
      spendPlaces: false,
      spendCoupons: false,
      receive: false,
      receivePlaces: false,
      receiveOffers: false,
      receiveProducts: false,
      market: false,
      cart: false,
      profile: {
        qrScan: true,
        scores: true,
        invite: true,
        tariffs: true,
        favorites: true,
        orders: false,
        coupons: false,
        giftsCards: false,
        activate: true,
      },
      footer: {
        copyright: false,
        app: false,
        payments: false,
        socials: false,
        companyInfo: false,
        contacts: false,
      },
      documents: {
        contacts: false,
        clientAgreement: true,
        agreements: false,
        policy: true,
        personalData: true,
        rules: false,
        licenseAgreement: true,
      },
    },
  },
];
